import React, { useState, useEffect } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'next-i18next';
import Slider from 'react-slick';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    backgroundColor: '#fff',
    paddingTop: 40,
    paddingBottom: 50,
    [theme.breakpoints.up('md')]: {
      paddingTop: 80,
      paddingBottom: 80,
    },
  },
  heading: {
    fontSize: 34,
    color: 'black',
    marginBottom: 19,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: 48,
      lineHeight: '57px',
    },
  },
  subHeading: {
    fontSize: 16,
    color: '#58657C',
    width: '100%',
    textAlign: 'center',
    fontFamily: 'CircularStd-Book',
    [theme.breakpoints.up('md')]: {
      fontSize: 28,
      lineHeight: '42px',
      maxWidth: 662,
      margin: '0 auto',
    },
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 44,
    paddingLeft: 20,
    paddingRight: 20,
    [theme.breakpoints.up('md')]: {
      alignItems: 'center',
      marginBottom: 58,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  contentContainer: {
    zIndex: 2,
    padding: 0,
  },
  registerButton: {
    backgroundColor: '#076BD1',
    borderRadius: 40,
    height: 38,
    display: 'inline-block',
    margin: '32px auto 42px auto',
    [theme.breakpoints.up('md')]: {
      margin: '40px auto 73px auto',
      height: 60,
    },
  },
  registerLabel: {
    color: '#fff',
    padding: '12px 36px',
    fontSize: 16,
    lineHeight: '19px',
    position: 'relative',
    top: 10,
    [theme.breakpoints.up('md')]: {
      top: 14,
      fontSize: 24,
      lineHeight: '28px',
    },
  },
}));

const Clients = () => {
  const classes = useStyles();
  const { t } = useTranslation('common');

  return (
    <div className={classes.root}>
      <div className={['container', classes.contentContainer].join(' ')}>
        <div className={classes.contentWrapper}>
          <Typography variant="h2" className={classes.heading}>
            {t('affiliate-heading-1')}
          </Typography>
          <Typography
            className={classes.subHeading}
            dangerouslySetInnerHTML={{ __html: t('affiliate-desc-1') }}
          ></Typography>
          <a
            href="https://api.whatsapp.com/send/?phone=60162433083&text=你好，想洽谈成为代理的详情。"
            className={classes.registerButton}
          >
            <span className={classes.registerLabel}>{t('affiliate-content-cta')}</span>
          </a>

          <Typography variant="h2" className={classes.heading}>
            {t('affiliate-heading-2')}
          </Typography>
          <Typography
            className={classes.subHeading}
            dangerouslySetInnerHTML={{ __html: t('affiliate-desc-2') }}
          ></Typography>
        </div>
      </div>
    </div>
  );
};

export default Clients;
